import { FileRepository } from "@/components/features";
import { useRedirectIfMatterDeleted } from "@/hooks/useRedirectIfMatterDeleted";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth/matters/$matterId/_layout/files")({
  component: RouteComponent,
  validateSearch: z.object({
    selectedId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { matterId } = Route.useParams();
  const { selectedId } = Route.useSearch();
  const { data: matterDetails } = useSuspenseQuery(
    retrieveMatterQueryOptions(matterId),
  );

  const matterData = matterDetails.data as unknown;
  const isDeletedMatter =
    Array.isArray(matterData) ||
    !(matterData as { id?: string } | undefined)?.id;
  useRedirectIfMatterDeleted({ matterId, isDeletedMatter });
  if (isDeletedMatter) {
    return null;
  }

  const matter = matterDetails.data;

  return (
    <div className="h-full min-h-0 overflow-hidden">
      <FileRepository
        matter={matter}
        compactPreviewLayout
        selectedFileId={selectedId}
      />
    </div>
  );
}
